"use client";

import React, { useEffect, useState } from 'react';
import MainLayout from '@/layouts/MainLayout';
import Image from 'next/image';
import PartnershipPost from '@/components/PartnershipPost';
import { getBounties } from '@/lib/api/services/bounties';
import { BountyDetail } from '@/lib/api/types';

const CreatorPage = () => {
  const [bounties, setBounties] = useState<BountyDetail[]>([]);

  useEffect(() => {
    const fetchBounties = async () => {
      const bounties = await getBounties();
      setBounties(bounties);
    };
    fetchBounties();
  }, []);

  return (
    <MainLayout fullWidthHero={true}>
      {/* Hero section */}
      <div className="relative mt-4 mx-6 rounded-2xl overflow-hidden min-h-[calc(80vh)] flex items-center justify-center">
        {/* Background Image */}
        <Image
          src="https://storage.googleapis.com/saved_media_assets/creator-background-1.avif"
          alt="Creator Program Background"
          layout="fill"
          objectFit="cover"
          quality={100}
          priority
          className="-z-10"
        />
        
        <div className="relative z-0 flex flex-col items-center text-center text-white px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl mb-4 sm:mb-6 leading-tight">
            Bounties
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl max-w-3xl mb-8 opacity-80">
            Promote featured brands. Get paid for views.
          </p>
        </div>
      </div>
      <div className="p-8 space-y-6">
        {bounties.map((bounty) => (
          <PartnershipPost
            key={bounty.bounty_id}
            bounty_id={bounty.bounty_id}
            name={bounty.name}
            cpm={bounty.cpm}
            total_budget={bounty.total_budget}
            budget_used={bounty.budget_used}
            description={bounty.description}
            offer_copy={bounty.offer_copy}
            offer_link={bounty.offer_link}
            image_url={bounty.image_url}
          />
        ))}
      </div>

    </MainLayout>
  );
};

export default CreatorPage;
